<template>
  <div id="us-tax-codes" class="fill-height align-start">
    <v-row class="g-container" no-gutters>
      <v-col cols="12">
        <h2 class="ma-0">Tax Viewer (US TIC)</h2>
        <v-text-field
          v-model="search"
          class="mt-4"
          dense
          outlined
          clearable
          prepend-inner-icon="mdi-magnify"
          label="Search by TIC code or label"
          @input="onSearch"
        />
        <v-simple-table class="mt-2">
          <thead>
            <tr>
              <th>Parent TIC Category</th>
              <th>TIC</th>
              <th>Label</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="row.usTaxCategoryId">
              <td>{{ row.parentTicCategory || '-' }}</td>
              <td>{{ row.ticCode }}</td>
              <td>{{ row.label }}</td>
              <td>{{ row.description }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from 'lodash'
import { fetchUsTaxCodes } from '@/services/products'

export default {
  data: () => ({
    search: '',
    rows: []
  }),
  created() {
    this.onSearch = _.debounce(this.load, 250)
  },
  async mounted() {
    await this.load()
  },
  methods: {
    async load() {
      this.rows = await fetchUsTaxCodes(this.search || '')
    }
  }
}
</script>
